import {gql} from "@apollo/client";

export const getUnauthorizedUser = gql`
    query GetUnauthorizedUser($token: String!) {
        getUnauthorizedUser(token: $token) {
            userId
            userName
            userEmail
        }
    }
`